import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, LayoutGrid, Users } from 'lucide-react';
const featured = [{
  icon: FileText,
  text: '100% PDF'
}, {
  icon: Zap,
  text: 'Acceso inmediato'
}, {
  icon: LayoutGrid,
  text: 'Pictogramas → Rutinas → Emociones → Autonomía'
}, {
  icon: Users,
  text: 'Para Padres y Familias TEA'
}];
export function TrustBar() {
  return <section className="bg-cream pb-10 pt-2 overflow-hidden" data-id="element-288">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-289">
        <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-290">
          {featured.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-center gap-2.5 bg-white rounded-2xl px-5 py-3.5 shadow-lg shadow-stone-200/60 border border-stone-100" data-id="element-291">
              <item.icon className="w-5 h-5 text-amber-500 flex-shrink-0" data-id="element-292" />
              <span className="text-sm md:text-base font-semibold text-teal-900 whitespace-nowrap" data-id="element-293">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}